import { createSlice } from "@reduxjs/toolkit";
import { AddSupplier, UpdateSupplier, GetSuppliers } from "services/supplier/supplier.service";
import { toast } from 'react-toastify';

export const supplierListSlice = createSlice({
  name: "supplierList",
  initialState: {
    supplierList: [],
    supplierListLoading: false,
    supplierListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetSuppliers.pending, (state) => {
      state.supplierListLoading = true
    });

    builder.addCase(GetSuppliers.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.supplierList = action.payload
      state.supplierListLoading = false
      state.supplierListError = null
    });

    builder.addCase(GetSuppliers.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.supplierListLoading = false
      state.supplierListError = action.error?.message
    });
  },
});

export const supplierAddSlice = createSlice({
  name: "supplierAdd",
  initialState: {
    supplierAdd: {},
    supplierAddLoading: false,
    supplierAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddSupplier.pending, (state) => {
      // toast.loading('We are adding the supplier 🤯')
      state.supplierAddLoading = true
    });

    builder.addCase(AddSupplier.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New supplier added successfully 👌');

      state.supplierAdd = action.payload
      state.supplierAddLoading = false
      state.supplierAddError = null
    });

    builder.addCase(AddSupplier.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the supplier 😣")

      state.supplierAddLoading = false
      state.supplierAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const supplierUpdateSlice = createSlice({
  name: "supplierUpdate",
  initialState: {
    supplierUpdate: {},
    supplierUpdateLoading: false,
    supplierUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateSupplier.pending, (state) => {
      // toast.loading('We are updating the supplier 🤯')
      state.supplierUpdateLoading = true
    });

    builder.addCase(UpdateSupplier.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Supplier update successfully 👌');

      state.supplierUpdate = action.payload
      state.supplierUpdateLoading = false
      state.supplierUpdateError = null
    });

    builder.addCase(UpdateSupplier.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the supplier 😣")

      state.supplierUpdateLoading = false
      state.supplierUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});
